import { Reveal, Eyebrow, BrandButton } from "@/components/ui-bits";

const fichaItems = [
  "Niñagordita, Madrid: Negra Ediciones, 2022",
  "Dos ediciones: 2022, 2024 (ilustrada por la autora)",
  "Otras versiones: ebook (Kindle), en venta en Amazon desde agosto 2022; Audiolibro en Spotify (en voz de la autora) — 2690 streams o descargas desde noviembre 2024",
  "Nota en Goodreads: 4.14/5",
  "Nota en Amazon: 5/5",
];

export default function Novela() {
  return (
    <section id="la-novela" data-testid="section-novela" className="py-24 sm:py-32 bg-[#F2EDE3]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <Reveal>
            <Eyebrow>El punto de partida: La Novela</Eyebrow>
            <h2 className="mt-3 font-display uppercase italic text-[#C20A78] text-5xl sm:text-6xl lg:text-7xl leading-none">
              Niñagordita
              <span className="block mt-2 not-italic font-display text-2xl sm:text-3xl tracking-wide text-[#C20A78]">
                de Belinda Palacios
              </span>
            </h2>
            <p className="mt-5 text-xl sm:text-2xl font-semibold text-[#141414]">
              ¿Cómo se destruye a una chica?
            </p>
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-[#141414]/85">
              Niñagordita nació de una pregunta que me tomó años poder responder:
              ¿cómo se destruye a una chica? Cómo una chica joven, sana y con todo
              el futuro por delante termina convencida de que no vale nada –de que
              su cuerpo no vale nada, de que sus sueños no valen nada, de que todo
              es inapropiado en ella y su voz no es importante–. Y hasta qué punto
              esto deja huellas en nosotras y puede comprometer a largo plazo
              nuestra autoestima y nuestra salud mental.
            </p>
            <figure className="mt-6 border-l-2 border-[#E84FA0] pl-4">
              <blockquote className="text-xs sm:text-sm italic leading-relaxed text-[#141414]/70">
                «La adolescencia como camino de autodestrucción. Una novela
                absorbente sobre el peso de la moral, de la culpa, del deseo de ser
                siempre otra. Un viaje asfixiante hacia la desaparición del yo.»
              </blockquote>
              <figcaption className="mt-2 text-xs uppercase tracking-wide text-[#6E6A66]">
                — Irene Reyes-Noguerol
              </figcaption>
            </figure>
          </Reveal>

          <Reveal delay={0.15}>
            <img
              src="/portada-novela.jpeg"
              alt="Portada de la novela Niñagordita, 2ª edición ilustrada, de Belinda Palacios (Negra Ediciones)"
              className="w-full max-w-md mx-auto lg:ml-auto rounded-2xl shadow-xl shadow-[#c20a78]/10 object-cover"
              draggable={false}
            />
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="mt-16 grid lg:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8 border border-[#ece5d6]">
              <h3 className="font-display text-3xl text-[#6E6A66] uppercase">Ficha del libro</h3>
              <ul className="mt-5 space-y-3">
                {fichaItems.map((t, i) => (
                  <li key={i} className="flex gap-3 text-sm sm:text-base text-[#141414]/85">
                    <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#E84FA0] shrink-0" />
                    <span>{t}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-white rounded-2xl p-8 border border-[#ece5d6]">
              <h3 className="font-display text-3xl text-[#6E6A66] uppercase">Contratapa</h3>
              <p className="mt-5 text-sm text-[#141414]/85 leading-relaxed">
                Talía quisiera ser como sus amigas, extrovertida como Caro, popular
                como Nicole, dejar de ser la niña gordita, la que suele quedarse
                callada porque no está segura de tener nada divertido que decir. Llega
                el programa de confirmación en cuarto de media, conocer gente nueva, el
                primer enamoramiento, Felipe. Y con él, el descubrimiento del sexo, los
                celos, el asco. Trata de escapar comenzando una relación nueva con
                Tomás, quien se comporta con ella como no había imaginado. Tali se
                desvanece tratando una y otra vez de complacerlos, y llega al límite de
                su capacidad de resistencia. Revienta, de un modo que no espera, y que
                quizás cambie su vida y su manera de entenderse a sí misma.
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <BrandButton
              testid="novela-buy-peru"
              href="https://www.buscalibre.pe/libros/search/?q=Ni%C3%B1agordita+Belinda+Palacios"
            >
              ¡Cómpralo en Perú!
            </BrandButton>
            <BrandButton
              testid="novela-buy-amazon"
              variant="outline"
              href="https://www.amazon.com/-/es/Belinda-Palacios-ebook/dp/B0B8MK887N"
            >
              ¡Cómpralo en Amazon!
            </BrandButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
